var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M19.924 10.383c.155-.374.069-.804-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15C19.404 11 19.77 10.756 19.924 10.383zM4.076 13.617c-.155.374-.069.804.217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5C4.596 13 4.23 13.243 4.076 13.617z"}}]})(props);
};
